import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonCheckbox } from '@ionic/react';

import './RegisterSecurity.css';
import { AccountSecurityQuestion } from '../../services/types/apitypes';
import QuestionsForm from '../shared/QuestionsForm';
import { cfgSecurityQuestionLength } from '../../utils/config';

type RegisterSecurityProps = {
  isValid: boolean;
  proceed: () => void;
  toQuestions: (question: number) => void;
  securityQuestions: AccountSecurityQuestion[];
  setAnswers: (answer: string, position: number) => void;
  agree: boolean;
  setAgree: (b: boolean) => void;
};

export default function RegisterSecurity({
  isValid,
  agree,
  setAgree,
  proceed,
  toQuestions,
  securityQuestions,
  setAnswers,
}: RegisterSecurityProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('register.securitytitle')}</h1>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('register.securityinfo', { n: cfgSecurityQuestionLength() })}
      </p>

      <QuestionsForm
        toQuestions={toQuestions}
        securityQuestions={securityQuestions}
        setAnswers={setAnswers}
      />

      <div className="pt-3 pb-3 register-security-tac">
        <div>
          <IonCheckbox
            checked={agree}
            onIonChange={(e) => setAgree(e.detail.checked)}
          ></IonCheckbox>
        </div>
        <div>
          <span>{t('register.confirmtac1')}</span>
          <a href={t('register.tacurl')!} rel={'noreferrer'} target={'_blank'}>
            {t('register.confirmtac2')}
          </a>
          <span>{t('register.confirmtac3')}</span>
        </div>
      </div>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('register.continue')}
        </IonButton>
      </div>
    </>
  );
}
